import { useCallback } from 'react';
import { useBoolean } from 'minimal-shared/hooks';

import { Box, Tooltip, Typography, IconButton, InputAdornment } from '@mui/material';

import { Iconify } from 'src/components/iconify';
import { Field } from 'src/components/hook-form';

import { FacebookLoginButton } from './connect-whatsapp';

export const WhatsappFields = ({ setFacebookDetail, t, FacebookDetail }: any) => {
  const show2FAPassword = useBoolean();

  const handleFaceBookDeteail = useCallback(
    (value: any) => {
      setFacebookDetail(value);
    },
    [setFacebookDetail]
  );

  return (
    <Box sx={{ my: 1 }}>
      <FacebookLoginButton handleFaceBookDeteail={handleFaceBookDeteail} />

      {FacebookDetail?.main_token && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Field.Text
            name="pin"
            label={t('2FA_PIN')}
            type={show2FAPassword.value ? 'text' : 'password'}
            placeholder={t('SET_6_DIGIT_PIN')}
            slotProps={{
              input: {
                inputProps: {
                  pattern: '[0-9]*',
                  inputMode: 'numeric',
                  maxLength: 6,
                  autoComplete: 'new-password',
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title={show2FAPassword.value ? t('HIDE') : t('SHOW')}>
                      <IconButton onClick={show2FAPassword.onToggle} edge="end">
                        <Iconify
                          icon={show2FAPassword.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'}
                        />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              },
              inputLabel: { shrink: true },
            }}
            helperText={t('PIN_HELP_TEXT')}
          />

          <Box sx={{ mt: 2, p: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {[1, 2, 3, 4, 5].map((i) => (
                <Box key={i} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                  <Iconify
                    icon="eva:checkmark-circle-2-fill"
                    sx={{ color: 'error.main', fontSize: 16, mt: 0.25, flexShrink: 0 }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ color: 'error.main', fontSize: '0.875rem', lineHeight: 1.5 }}
                  >
                    {t(`PIN_WARNING_${i}`)}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
          <Field.Checkbox name="pinAcknowledge" label={t('PIN_ACKNOWLEDGEMENT')} />
        </Box>
      )}
    </Box>
  );
};
